<template>
    <div>
        <vue-element-loading :active="isLoading" is-full-screen text="Please wait..." />
        <table  style="height:150px;margin-top:30px;">
            <tr>
                <td width="600px">
                    <p class="title">FFT(Original)</p>
                    <lineChart
                        :chart-data="lineChartData1"
                        class="chart-height"
                    ></lineChart>
                </td>
                <td width="50%">
                    <p class="title">FFT(Original + Pressure mean)</p>
                    <lineChart
                        :chart-data="lineChartData"
                        class="chart-height"
                    ></lineChart>
                </td>
            </tr>
            
        </table>
        <table  style="height:150px;margin-top:30px;">
            <tr>
                <td width="600px">
                    <div>
                        <!-- <p class="title">MAX: {{this.rowMax}}({{this.rowMax_index}}HZ)  MIN: {{this.rowMin}}({{this.rowMin_index}}HZ)</p> -->
                        <span class="title">MAX: {{this.rowMax}}({{this.rowMax_index}}HZ)</span>
                        <span class="title"> MIN: {{this.rowMin}}({{this.rowMin_index}}HZ)</span>
                        <span><b-button variant="outline-secondary" style="margin-left:200px;" @click="downloadFFTCSV('1')">EXPO</b-button></span>
                    </div>
                    
                    <div style="margin-top:10px;width:520px;height:400px;display:block;overflow-y:auto;">
                        <table class="table table-hover" style="text-align:center;">
                            <thead>
                                <tr>
                                    <th scope="col" style="text-align:center;">HZ</th>
                                    <th scope="col" style="text-align:center;">Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in rowData" :key="index">
                                    <td style="vertical-align:middle;">
                                        {{index}} HZ
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{item}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
                <td width="50%">
                    <div style="margin-left:30px;">
                        <!-- <p class="title">MAX: {{this.rowMax}}({{this.rowMax_index}}HZ)  MIN: {{this.rowMin}}({{this.rowMin_index}}HZ)</p> -->
                        <span class="title">MAX: {{this.pressureMax}}({{this.pressureMax_index}}HZ)</span>
                        <span class="title"> MIN: {{this.pressureMin}}({{this.pressureMin_index}}HZ)</span>
                        <span><b-button variant="outline-secondary" style="margin-left:200px;" @click="downloadFFTCSV('2')">EXPO</b-button></span>
                    </div>
                    
                    <div style="margin-top:10px;width:520px;height:400px;display:block;overflow-y:auto;margin-left:30px;">
                        <table class="table table-hover" style="text-align:center;">
                            <thead>
                                <tr>
                                    <th scope="col" style="text-align:center;">HZ</th>
                                    <th scope="col" style="text-align:center;">Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in pressureData" :key="index">
                                    <td style="vertical-align:middle;">
                                        {{index}} HZ
                                    </td>
                                    <td style="vertical-align:middle;">
                                        {{item}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                </td>
            </tr>
            
        </table>
    </div>
</template>

<script>
import LineChart from '@/components/chart/lineChart.vue';
export default {
    components: {
        LineChart
    },
    data() {
        return {
            type: this.$route.query.type,
            report_id: '',
            db_model: 'db',
            lineChartData: {
                labels: [],
                datasets: []
            },
            lineChartData1: {
                labels: [],
                datasets: []
            },

            rowData: [],
            rowMax: 0,
            rowMin: 0,
            rowMax_index: 0,
            rowMin_index: 0,

            pressureData: [],
            pressureMax: 0,
            pressureMin: 0,
            pressureMax_index: 0,
            pressureMin_index: 0,
            isLoading: false,
            // isLoading2: false,
        }
    },
    created(){
        const report = JSON.parse(sessionStorage.getItem('client_report'));
        this.report_id = report.id;
        this.getReport()
    },
    methods: {
        getReport() {
            this.isLoading = true
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fft`;
            const json = {
                report_id: this.report_id,
                db_model: this.db_model
            }
            this.$http.post(api, json).then((res) => {
                const status = res.data.Status;
                if(status === 'success'){
                    this.rowData = res.data.data.fft_row;
                    this.rowMax = Math.max(...this.rowData)
                    this.rowData.forEach((item, index) => item === this.rowMax ? this.rowMax_index = index-1: null)
                    this.rowMin = Math.min(...this.rowData)
                    this.rowData.forEach((item, index) => item === this.rowMin ? this.rowMin_index = index-1: null)

                    this.pressureData = res.data.data.fft_pulse
                    this.pressureMax = Math.max(...this.pressureData)
                    this.pressureData.forEach((item, index) => item === this.pressureMax ? this.pressureMax_index = index-1: null)
                    this.pressureMin = Math.min(...this.pressureData)
                    this.pressureData.forEach((item, index) => item === this.pressureMin ? this.pressureMin_index = index-1: null)

                    this.drawPulse(res.data.data.fft_pulse);
                    this.drawPulse1(res.data.data.fft_row);
                }
                this.isLoading = false
            })
        },
        downloadFFTCSV(type) {
            this.isLoading = true;
            var data = []
            var text = ''
            if(type === '1'){
                data = this.rowData
                text = "Original"
            }else{
                data = this.pressureData
                text = "Original Pressure mean"
            }
            const api = `${process.env.VUE_APP_APIPATH}/client/report/fft/csv`;
            const json = {
                report_id: this.report_id,
                row: data,
                model: text
            }
            this.$http.post(api, json).then((res) => {
                console.log(res)
                const status = res.data.Status;
                if(status === 'success'){
                    const url = res.data.data;
                    window.open(url, '_blank')
                    this.isLoading = false;
                }
            })
        },
        drawPulse(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: '',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData = result;
        },
        drawPulse1(pulse) {
            let pulseAry = [];
            let labAry = [];
            pulseAry = pulse;
            
            pulseAry.splice(0, 1);
            pulse = pulseAry.join(",");
            pulseAry.forEach((item, i) => {
                labAry.push(i);
            })
            
            let result = {
                labels: labAry,
                datasets: [
                {
                    label: '',
                    backgroundColor: "transparent",
                    data: pulseAry,
                    borderColor: "rgba(29, 33, 36, .2)",
                    pointBackgroundColor: "rgba(171, 71, 188, 1)",
                    pointRadius: 1,
                }
                ]
            };
            this.lineChartData1 = result;
        },
    }
}
</script>